import { render, staticRenderFns } from "./ModifyInsued.vue?vue&type=template&id=1371861f&"
import script from "./ModifyInsued.vue?vue&type=script&lang=js&"
export * from "./ModifyInsued.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports